import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row justify-center q-my-md" }

import { nextTick, ref, watch } from 'vue';
import { WithRelations } from 'SharedDir/declarations/shared';
import { QInfiniteScroll } from 'quasar';
import { Chats } from 'SharedDir/declarations/chats';
import Message from 'SharedDir/modules/Chats/Message.vue';

/**
 * "Умная" компонента с бездонным колодцем сообщений чата
 * сама решает когда пора подгрузить еще, вобщем небольшая
 * обертка над квазаровским бесконечным скролом
 * продьюсит такое же события при запросе следующей пачке сообщений
 */

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'MessagesList' },
  __name: 'MessagesList',
  props: {
    messages: {},
    dense: { type: Boolean, default: false }
  },
  emits: ["load", "delete"],
  setup(__props: any, { expose: __expose, emit: __emit }) {


const props = __props;
const emits = __emit;

watch(
  () => props.messages,
  (n, o) => {
    console.debug('Messages are changed: ', n, o);
  }
);
const refMessageContainer = ref<HTMLDivElement>(null as any);
const refInfiniteScroll = ref<QInfiniteScroll>(null as any);

/**
 * Событие начала подгрузки елементов бесконечного скролла
 */
function proxyLoad(index: number, done: () => void) {
  console.debug('Proxying load more ...');
  emits('load', index, done);
}

/**
 * Прокручиваемся вниз, до упора
 */
async function scrollToBottom() {
  await nextTick();
  refMessageContainer.value.scrollTop = refMessageContainer.value.scrollHeight;
}

function reset() {
  refInfiniteScroll.value.reset();
  refInfiniteScroll.value.resume();
}
__expose({ reset, scrollToBottom });

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "refMessageContainer",
    ref: refMessageContainer,
    class: "scroll-y"
  }, [
    _createVNode(_unref(QInfiniteScroll), {
      ref_key: "refInfiniteScroll",
      ref: refInfiniteScroll,
      reverse: "",
      onLoad: proxyLoad
    }, {
      loading: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_spinner, {
            color: "brand",
            name: "dots",
            size: "40px"
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
          return (_openBlock(), _createBlock(Message, {
            key: message.id,
            class: "base-margin-y",
            dense: _ctx.dense,
            message: message,
            onDelete: ($event: any) => (_ctx.$emit('delete', message))
          }, null, 8, ["dense", "message", "onDelete"]))
        }), 128))
      ]),
      _: 1
    }, 512)
  ], 512))
}
}

})